module.exports = __webpack_public_path__ + "00119a4bd6ceb55e29da06c8ae99f25c.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/icons/newzealand_icon.png
// module id = 1228
// module chunks = 0